import { AuthNextStep } from "@sellar-io/common";
import {
  type AuthNextStepRequestType,
  type AuthNextStepResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import {
  apiV2Request,
  apiV2AssertResponse,
  ApiV2RequestScope,
} from "../apiV2Request";

export const useAuthNextStep = () =>
  useMutation({
    networkMode: "always",
    retry: false,
    mutationFn: async (
      data: AuthNextStepRequestType,
    ): Promise<AuthNextStepResponseType> => {
      const response = await apiV2Request({
        scope: ApiV2RequestScope.Public,
        method: "post",
        path: "auth/next-step",
        data,
        timeout: 15000,
      });
      const result = apiV2AssertResponse<
        unknown,
        { data: AuthNextStepResponseType }
      >(response).data;
      if (
        result?.nextStep !== AuthNextStep.SignIn &&
        result?.nextStep !== AuthNextStep.SignUp
      ) {
        throw new Error("Unable to check sign-in details. Please try again.");
      }
      return result;
    },
  });
